<template>
    <div style="padding-top: 20px">
        <div>
            <div class="tabs-btn-ctn">
                <div class="tab-btn-item" @click="tabToggle(0)" :class="{'tab-active':tabInd == 0}">普通发票</div>
                <div class="tab-btn-item" @click="tabToggle(1)" :class="{'tab-active':tabInd == 1}">增值税专用发票</div>
            </div>
            <div class="invoice-row">
                <div class="key">
                    发票抬头：
                </div>
                <div class="value">
                    <div class="header-ctn" v-show="tabInd == 0">
                        <div :key="index" v-for="(item,index) in header1"
                             class="add-item"
                             @click="changeHeader(index)"
                             :class="{'target-checked':headerChecked == index}">
                            <div v-show="!item.editing">{{item.Title}}</div>
                            <input type="text"
                                   v-show="item.editing"
                                   v-model="item.editingValue"
                                   class="editingValue"
                                   autofocus>
                            <div class="header-ops">
                                <span @click.stop="headerEdit(index)" v-show="!item.editing">编辑</span>
                                <span @click.stop="headerSave(index)" v-show="item.editing">保存</span>
                                <span @click.stop="headerDel(index)">删除</span>
                            </div>
                        </div>
                    </div>
                    <div class="header-ctn" v-show="tabInd == 1">
                        <div :key="index" v-for="(item,index) in header2"
                             class="add-item"
                             @click="changeHeader(index)"
                             :class="{'target-checked':headerChecked == index}">
                            <div v-show="!item.editing">{{item.Title}}</div>
                            <input type="text"
                                   v-show="item.editing"
                                   v-model="item.editingValue"
                                   class="editingValue"
                                   autofocus>
                            <div class="header-ops">
                                <span @click.stop="headerEdit(index)" v-show="!item.editing">编辑</span>
                                <span @click.stop="headerSave(index)" v-show="item.editing">保存</span>
                                <span @click.stop="headerDel(index)">删除</span>
                            </div>
                        </div>
                    </div>
                    <div class="addHeader-main" v-show="addHeaderVisible">
                        <el-input type="text" size="small" class="addHeader-input" v-model="addHeaderValue" />
                        <el-button class="btn-primary" size="small" @click.stop.native="addHeader">保存抬头</el-button>
                    </div>
                    <div class="addHeader-btn" @click.stop="showAddHeader()">新增抬头</div>
                </div>
            </div>
            <div class="invoice-row">
                <div class="key">
                    <span v-show="tabInd==0">纳税人识别号：</span>
                    <span v-show="tabInd==1">统一社会信用代码：</span>
                </div>
                <div class="value">
                    <el-input type="text" size="small" style="width: 420px" v-model="CreditCode" :readonly="editCreditCode" />
                </div>
            </div>
            <div class="invoice-row">
                <div class="key">
                    发票内容：
                </div>
                <div class="value header-content">
                    <div :key="index" v-for="(item,index) in headerContent"
                         class="add-item"
                         style="width: 80px;text-align: center"
                         @click.stop="changeHeaderContent(index)"
                         :class="{'target-checked':headerContentChecked == index}">
                        {{item.Text}}
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <el-button @click="cancelInvoice">取 消</el-button>
            <el-button class="btn-primary" @click="saveInvoice">保 存</el-button>
        </div>
    </div>
</template>
<script>
    export default {
        name: '',
        props:['orderId'],
        components: {

        },
        data(){
            let userMsg = this.$util.getLocalStorage("userMsg");
            return {
                userMsg:userMsg,
                editCreditCode:true,
                CreditCode:'',  // 统一代码
                headerContentChecked:0,
                headerContent:['不开发票','商品明细'], // 发票内容
                addHeaderValue:'',
                addHeaderVisible:false,
                header:[],
                header1:[],// 普通发票title
                header2:[],// 增值税发票title
                headerChecked:0,
                tabInd:0,
            }
        },
        mounted(){
            this.getInvoiceHeader()
            this.getInvoiceContentList()
        },
        methods:{
            doNothing(){},
            // 清空数据
            clearData(){
                for (let i=0;i<this.header.length;i++){
                    this.header[i].editing = false
                    this.header[i].editingValue = ""
                }
            },
            // 获取发票内容列表
            getInvoiceContentList (){
                this.$util.axiosGet({
                    url:'/api/MallInvoice/GetInvoiceContentList',
                    data: {},
                }).then((res)=>{
                    let data = res.data
                    this.headerContent = data
                }).catch(()=>{})
            },
            // 删除发票抬头
            headerDel(index) {
                let that = this
                let targetList = this.tabInd == 0? this.header1:this.header2
                let target = targetList[index]
                this.$util.elConfirm({
                    content: '确定要删除该抬头吗？',
                    confirm() {
                        that.$util.axiosPost({
                            url: '/api/MallInvoice/DeleteInvoiceTitle',
                            data: {
                                InvoiceTitleId: target.InvoiceTitleId,
                                UserId: that.userMsg.EmployeeId,
                            },
                        }).then((res) => {
                            that.$util.warningMsg('删除抬头成功')
                            that.getInvoiceHeader()
                        }).catch(()=>{})
                    }

                })
            },
            // 获取企业发票抬头列表
            getInvoiceHeader(){
                this.$util.axiosGet({
                    url:'/api/MallInvoice/GetInvoiceTitleList',
                    data: {
                        UserId: this.userMsg.EmployeeId,
                    },
                }).then((res)=>{
                    this.header1 = []
                    this.header2 = []
                    let data = res.data
                    for (let i=0;i<data.length;i++){
                        data[i].editingValue = ''
                        data[i].editing = false
                        if (data[i].TitleType == 0){
                            this.header1.push(data[i])
                        }
                        else if(data[i].TitleType == 1){
                            this.header2.push(data[i])
                        }
                    }
                    this.header = data
                    this.CreditCode = this.header1[0]?this.header1[0].CreditCode:''
                }).catch(()=>{})
            },
            // 开发票
            saveInvoice(){
                let targetList = null
                if(this.tabInd == 0){
                    targetList = this.header1
                }
                else {
                    targetList = this.header2
                }
                this.$util.axiosPost({
                    url:'/api/MallInvoice/ApplyInvoice',
                    data: {
                        CreditCode: targetList[this.headerChecked].CreditCode,
                        InvoiceContent: this.headerContent[this.headerContentChecked].Text,
                        OrderIds: this.orderId,
                        TitleId: targetList[this.headerChecked].InvoiceTitleId,
                        TypeName: this.tabInd == 0 ?'普通发票':'增值税专用发票',
                        UserId: this.userMsg.EmployeeId
                    },
                }).then((res)=>{
                    this.$util.warningMsg('开发票成功')
                    this.$emit('closeInvoice')
                })
            },
            // 取消新增发票
            cancelInvoice(){
                this.$emit('closeInvoice')
            },
            // 变更发票内容
            changeHeaderContent(index){
                this.headerContentChecked = index
            },
            // 显示新增发票需要的输入框
            showAddHeader(){
                this.addHeaderVisible = true
                this.editCreditCode = false
                this.CreditCode = ''
            },
            // 新增抬头
            addHeader(){
                if (!this.addHeaderValue){
                    this.$util.warningMsg('请填写抬头信息')
                    return
                }
                // CreditCode
                if (!this.CreditCode){
                    this.$util.warningMsg(this.tabInd == 0?'请填写纳税人识别号':'请填写统一社会信用代码')
                    return
                }
                let _header = {
                    Title:this.addHeaderValue,
                    CreditCode:this.CreditCode,
                    editing:false,
                    editingValue:'',
                }
                if (this.tabInd == 0){
                    this.header1.unshift(_header)
                }
                else {
                    this.header2.unshift(_header)
                }
                this.addHeaderValue = ''
                this.addHeaderVisible = false
                this.$util.axiosPost({
                    url:'/api/MallInvoice/SaveInvoiceTitle',
                    data: {
                        TitleType:this.tabInd,
                        UserId:this.userMsg.EmployeeId,
                        InvoiceTitleId:'',
                        Title:_header.Title,
                        CreditCode:_header.CreditCode,
                    },
                }).then(()=>{
                    this.$util.warningMsg('新增抬头成功')
                    this.CreditCode = ''
                    this.getInvoiceHeader()
                })
            },
            // 保存抬头
            headerSave(index){
                let targetList = this.tabInd == 0? this.header1:this.header2
                let target = targetList[index]
                if (!target.editingValue){
                    this.$util.warningMsg('请填写抬头信息')
                    return
                }
                if (!this.CreditCode){
                    this.$util.warningMsg('请填写识别号或统一代码')
                    return
                }
                target.CreditCode = this.CreditCode
                target.Title = target.editingValue
                target.editing = false
                this.$util.axiosPost({
                    url:'/api/MallInvoice/SaveInvoiceTitle',
                    data: {
                        TitleType:this.tabInd,
                        UserId:this.userMsg.EmployeeId,
                        InvoiceTitleId:target.InvoiceTitleId,
                        Title:target.Title,
                        CreditCode:target.CreditCode,
                    },
                }).then((res)=>{
                    this.$util.warningMsg('修改抬头成功')
                })
            },
            // 修改抬头
            headerEdit(index){
                this.headerChecked = index
                let targetList = this.tabInd == 0? this.header1:this.header2
                let target = targetList[index]
                for (let i=0;i<targetList.length;i++){
                    targetList[i].editing = false
                    targetList[i].editingValue = ""
                }
                target.editing = true
                target.editingValue = target.Title
                this.CreditCode = target.CreditCode
                this.editCreditCode = false
            },
            // 更换抬头
            changeHeader(index){
                let targetList = this.tabInd == 0? this.header1:this.header2
                let target = targetList[index]
                for (let i=0;i<targetList.length;i++){
                    targetList[i].editing = false
                }
                this.addHeaderValue = ''
                this.editCreditCode = true
                this.addHeaderVisible = false
                this.headerChecked = index
                this.CreditCode = target.CreditCode
            },
            // 切换发票tab
            tabToggle(i) {
                this.tabInd = i;
                this.addHeaderVisible = false
                this.CreditCode = this['header'+(i+1)][this.headerChecked].CreditCode
            },
        }
    }
</script>
<style lang="less" scoped>
    .editingValue {
        border: none;
        width: 300px;
        padding-left: 5px;
        border-radius: 5px;
    }
    .header-content {
        display: flex;
    }
    .addHeader-input {
        margin-right: 10px;
    }
    .addHeader-main {
        display: flex;
        padding-top: 10px;
    }
    .header-ops {
        span {
            display: inline-block;
            margin-left: 10px;
            color: @theme;
        }
    }
    .addHeader-btn {
        padding-top: 15px;
        color:@theme;
        cursor: pointer;
    }
    .header-ctn {
        max-height: 200px;
        overflow: auto;
    }
    .add-item {
        border-radius: 5px;
        display: flex;
        height: 32px;
        align-items: center;
        justify-content: space-between;
        width: 420px;
        text-align: left;
        margin-bottom: 10px;
        .header-ops {
            display: none;
        }
        &:hover {
            .header-ops {
                display: block;
            }
        }
    }
    .invoice-row {
        display: flex;
        padding-top: 15px;
        .key {
            width: 150px;
            text-align: right;
            padding-top: 8px;
        }
    }
    .dialog-footer {
        text-align: right;
    }
    .tabs-btn-ctn{
        border-bottom: 1px solid @border1Color;
        .tab-btn-item {
            flex-grow: 0;
            width: 160px;
            padding: 0 10px;
            border-bottom: none;
        }
    }
</style>
